import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ChangeOrderModel, DataTablesResponse } from '../models/common';
import { CupraModelModel } from '../models/cupramodel';

@Injectable({
  providedIn: 'root'
})

export class CupraModelService {

  private pathAPI = environment.urlAPI;
  private controller = "CupraModel/";

  constructor(private http: HttpClient) { }

  public searchData(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public post(data: any): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public get(id: string): Observable<CupraModelModel> {
    return this.http.get<CupraModelModel>(this.pathAPI + this.controller + id);
  }

  public getAllActive(): Observable<CupraModelModel[]> {
    return this.http.get<CupraModelModel[]>(this.pathAPI + this.controller + 'GetAllActive');
  }

  public getAllModels(): Observable<CupraModelModel[]> {
    return this.http.get<CupraModelModel[]>(this.pathAPI + this.controller + 'GetAllModels');
  }

  public searchDataOrder(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableOrder', data);
  }

  public changeOrder(data: ChangeOrderModel[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public saveFiles(fileDocument: File): Observable<any> {
    let formData: FormData = new FormData();
    if (fileDocument != undefined) {
      formData.append('fileImage', fileDocument, fileDocument.name);
    }
    return this.http.post<any>(this.pathAPI + this.controller + 'SaveFiles', formData);
  }

  public getFiles(id: string): Observable<Blob> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetFiles/' + id;
    return this.http.get<Blob>(endpoint, requestOptions);
  }

}
